import { Injectable } from "@angular/core";
import { Orgao } from "../../models/core/orgao.model";
import { Usuario } from "../../models/core/usuario.model";
import { ParametroDiario } from "../../models/diario/parametro-diario.model";
import { LocalUser } from "../../models/login/local-user";
import { STORAGE_KEYS } from "../../util/config/storage.keys.config";

@Injectable()
export class StorageService {

    getSistema(): string {
        return 'diario-oficial';
    }

    getLocalUser(): LocalUser {
        let usr = localStorage.getItem(STORAGE_KEYS.localUser);
        if (usr == null) {
            return null;
        }
        else {
            return JSON.parse(usr);
        }
    }

    setLocalUser(obj: LocalUser) {
        if (obj == null) {
            localStorage.removeItem(STORAGE_KEYS.localUser);
            localStorage.removeItem(STORAGE_KEYS.orgao);
            localStorage.removeItem(STORAGE_KEYS.user);
        }
        else {
            localStorage.setItem(STORAGE_KEYS.localUser, JSON.stringify(obj));
        }
    }

    getOrgao(): Orgao {
        let str = localStorage.getItem(STORAGE_KEYS.orgao);
        if (str != null) {
            return JSON.parse(str);
        }
        else {
            return null;
        }
    }

    setOrgao(obj: Orgao) {
        if (obj != null) {
            localStorage.setItem(STORAGE_KEYS.orgao, JSON.stringify(obj));
        }
        else {
            localStorage.removeItem(STORAGE_KEYS.orgao);
        }
    }

    getUser(): Usuario {
        let str = localStorage.getItem(STORAGE_KEYS.user);
        if (str != null) {
            return JSON.parse(str);
        }
        else {
            return null;
        }
    }

    setUser(obj: Usuario) {
        if (obj != null) {
            localStorage.setItem(STORAGE_KEYS.user, JSON.stringify(obj));
        }
        else {
            localStorage.removeItem(STORAGE_KEYS.user);
        }
    }

    getParametro(): ParametroDiario {
        let str = localStorage.getItem(STORAGE_KEYS.param);
        if (str != null) {
            return JSON.parse(str);
        }
        else {
            return null;
        }
    }

    setParametro(obj: ParametroDiario) {
        if (obj != null) {
            localStorage.setItem(STORAGE_KEYS.param, JSON.stringify(obj));
        }
        else {
            localStorage.removeItem(STORAGE_KEYS.param);
        }
    }    
}
